import { Store } from '@ngrx/store';
import { DealerState } from '../../store/dealer/dealer.reducer';
import * as fromSelectors from '../../store/dealer/dealer.selectors';
import { Injectable, OnDestroy } from '@angular/core';
import { cloneDeep } from 'lodash';
import * as fromDealerActions from '../../store/dealer/dealer.actions';
import { LoadNotificationDashboardData } from '../../store/service-appointment/service-appointment.actions';
import { ServiceAppointmentState } from '../../store/service-appointment/service-appointment.reducer';
import * as fromServiceApptSelectors from '../../store/service-appointment/service-appointment.selectors';
import { Department } from '@signal/asp-data-commons';
import { Departments } from '../enums/departments.enum';
import { TranslateService } from '@ngx-translate/core';
import { unsubscribeSubscriptions } from './util.service';
import { SubscriptionList } from '../models/asp.types';

@Injectable()
export class DashboardOverlayService implements OnDestroy {
    data: any[];
    dataContentsResponse;
    badgeCount = 0;
    isError: boolean = false;
    totalServiceAdvisors: number;
    totalServiceTechnicians: number;
    shopMaxSlotWeekTotal: number;
    shopMaxHrsWeeKTotal: number;
    department:string = Departments.SERVICE;
    totalAddedVehicles: number;
    totalOnlineVehicles: number;
    totalOnlineChecklistItems: number;
    private subs: SubscriptionList = {};

    constructor(private readonly dealerState: Store<DealerState>,
        private readonly serviceAppointmentStore: Store<ServiceAppointmentState>,
        private readonly translate: TranslateService) {}

    setValuesAndData() {
        this.subs.dashboardData = this.serviceAppointmentStore.select(fromServiceApptSelectors.selectNotificationDashboardData).subscribe((results: any) => {
            if (results && results.length > 0) {
                this.totalServiceAdvisors = results.find(x => x.key === "totalAdvisors")?.value;
                this.totalServiceTechnicians = results.find(x => x.key === "totalTechnicians")?.value;
                this.totalAddedVehicles =  results.find(x => x.key === "totalVehicles")?.value;
                this.totalOnlineVehicles =  results.find(x => x.key === "onlineVehicles")?.value;
                this.totalOnlineChecklistItems = results.find(x=> x.key === 'checklistTotal')?.value;

                this.setdata(results);
            }
        });
    }
    getData() {
        return this.data;
    }
    getdatavalue(department:string) {
        this.subs.overlayDetails = this.dealerState.select(fromSelectors.dealerDashboardOverlayDetails).subscribe(response => {
            if(response){
                const dataDepartmentWise = response.filter(res=> res.department === department);
                this.department = department;
                this.data = cloneDeep(dataDepartmentWise);
                this.setValuesAndData();
            }
           
        });
    }
    setdata(results) {
        this.isError = false;
        if (this.data !== null) {
            this.badgeCount = 0;
            this.data.forEach(item => {
                for (const eachchildren of item.children) {
                    for (const result of results) {
                        switch (eachchildren.key === result.key) {
                            case true: {
                                eachchildren.value = result.value;
                                this.setButtonRequired(eachchildren);
                                break;
                            }
                            default:
                                break;
                        }
                    }
                }
            }
            );
        }
    }
    setButtonRequired(eachchildren) {
        eachchildren.isButtonRequired = false;
        if ((eachchildren.key !== 'checkList' && (eachchildren.value === 0 || eachchildren.value === "OFF" || eachchildren.value === "Inactive")) || 
        (eachchildren.key === 'checkList' && eachchildren.value > 0)) {
            this.badgeCount++;
            eachchildren.isButtonRequired = true;
        }
        if (this.badgeCount > 0){
             this.isError = true;
        }
        eachchildren.value = eachchildren.key.includes("employees") ? eachchildren.value + ` ${this.translate.instant('serviceSchedule.of')} ` + this.totalServiceAdvisors : eachchildren.value;
        eachchildren.value = eachchildren.key.includes("activetech") ? eachchildren.value + ` ${this.translate.instant('serviceSchedule.of')} ` + this.totalServiceTechnicians : eachchildren.value;
        eachchildren.value = eachchildren.key.includes("shop") ? this.translate.instant('serviceSchedule.weeklyTotal')+ eachchildren.value : eachchildren.value ;
        eachchildren.value = eachchildren.key.includes("onlineVehicles") ? eachchildren.value + ` ${this.translate.instant('serviceSchedule.of')} ` + this.totalAddedVehicles : eachchildren.value;
        eachchildren.value = eachchildren.key.includes("checkList") ? this.totalOnlineChecklistItems - eachchildren.value + 
        ` ${this.translate.instant('serviceSchedule.of')} ` + this.totalOnlineChecklistItems : eachchildren.value;
    }
    dispatchActions(department) {
        const payload = { department };
        this.dealerState.dispatch(new fromDealerActions.LoadOverlayDashboardContents());
        this.serviceAppointmentStore.dispatch(new LoadNotificationDashboardData(payload));
    }

    ngOnDestroy() {
        unsubscribeSubscriptions(this.subs);
    }

}